import React, {useEffect, useMemo, useState} from 'react'
import {premioFields, mapPremioToTable} from "./premio-fields"
import {Paper} from "@mui/material"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import PropTypes from "prop-types"
import {pasteTableFromClipboard} from "../../../../utils/csv-utils"
import {useLocation} from "react-router-dom"
import MotorPremioService from "../../../../../../../services/motor-premio-service"
import {copyTableToClipboard} from "src/v2/utils/table-clipboard"
import {formatDecimalSeparator} from "src/v2/utils/formatter/format-number"
import {normalizeDecimalInput, normalizeDecimalFields} from "../../../../utils/convert-fields"

const PremioTable = ({
                         setLoading,
                         idCaracteristica,
                         premioPublicado,
                         tableData,
                         setTableData,
                         clearTable
                     }) => {

    const service = useMemo(() => new MotorPremioService(), [])
    const [tableKey, setTableKey] = useState(Math.random() * 10)
    const location = useLocation()
    const navigationState = location.state

    useEffect(() => {
        if (!idCaracteristica) return

        const origem = navigationState?.origem
        if (origem === "ver") {
            loadPremio()
        }
    }, [idCaracteristica, navigationState])

    useEffect(() => {
        if (navigationState?.origem !== "duplicar") return
        const dadosOrigem =
            navigationState?.Data?.Premio?.Premios ?? []
        
        const formatted = mapPremioToTable(dadosOrigem)
        premioPublicado(false)
        setTableData(formatted)
        setTableKey(Math.random() * 10)
    }, [navigationState, premioPublicado, setTableData])

    const loadPremio = () => {
        setLoading(true)
        service.getPremio(idCaracteristica)
            .then(response => {
                const {body} = response
                const {Premios} = body

                if (Premios.length > 0) {
                    premioPublicado(true)
                    const formatted = mapPremioToTable(Premios)
                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    loadPremioTemporario()
                }
            })
            .catch(error => console.error("Erro getPremio:", error))
            .finally(() => setLoading(false))
    }

    const loadPremioTemporario = () => {
        setLoading(true)

        service.getTemporarioPremio(idCaracteristica)
            .then(response => {
                const bodyTemp = response?.body || response?.data

                if (bodyTemp) {
                    // Extrair array de Premio do objeto temporário
                    const premios = Array.isArray(bodyTemp)
                        ? bodyTemp
                        : bodyTemp?.Premios || []

                    const formatted = mapPremioToTable(premios)

                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    console.warn("Nenhum dado temporário encontrado")
                }
            })
            .catch(error => console.error("Erro getTemporarioPremio:", error))
            .finally(() => setLoading(false))
    }

    return (
        <Paper sx={{mt: 2}}>
            <DynamicColumnTable
                key={tableKey}
                actionButtons={true}
                copyData={() => copyTableToClipboard(
                    tableData,
                    premioFields.map(field => field.key),
                    (field, value) => field === "ValorPremio"
                        ? formatDecimalSeparator(normalizeDecimalInput(value), "")
                        : value
                )}
                pasteData={() => pasteTableFromClipboard(
                    premioFields,
                    rows => setTableData(normalizeDecimalFields(rows, {ValorPremio: "Valor Prêmio"})),
                    {validateHeader: true}
                )}
                clearTable={() => clearTable(setTableData)}
                fields={premioFields}
                items={tableData}
                setItems={setTableData}
            />
        </Paper>
    )
}

PremioTable.propTypes = {
    setLoading: PropTypes.func,
    idCaracteristica: PropTypes.number,
    premioPublicado: PropTypes.func,
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    clearTable: PropTypes.func,
}

export default PremioTable